import React from "react";

import { get } from "lodash";
import { Box, H5, Divider } from "orcs-design-system";
import { useAuth } from "src/contexts/global/GlobalContext";

import { useWorkspace } from "src/contexts/global/WorkspaceContext";

import ExternalAppLinks from "src/components/Nav/ExternalAppLinks";
import InternalAppLinks from "src/components/Nav/InternalAppLinks";
import shouldShowReportsLink from "src/components/Nav/utils/reports.utils";
import { useAuth0 } from "src/contexts/auth0Provider";
import { useCheckReportingResourceProvisioned } from "src/contexts/global/WorkspaceContext/WorkspaceContext";
import { LINK_LOCATIONS } from "src/consts/externalLinks";
import { filterLinksByLocationAndUserRoles } from "src/util/externalLinks";

const AppSwitcherContent = () => {
  const auth = useAuth();
  const { user } = useAuth0();
  const { roles } = auth;
  const workspace = useWorkspace();
  const isReportingInfraProvisioned = useCheckReportingResourceProvisioned();

  const helpConfig = get(workspace, "config.helpConfig");
  const externalContents = get(helpConfig, "externalContents");
  const visibleExternalLinks = filterLinksByLocationAndUserRoles({
    externalContents,
    targetLocations: LINK_LOCATIONS.APPS,
    userRoles: roles,
  });

  const showReportsLink = shouldShowReportsLink({
    workspace,
    isReportingInfraProvisioned,
    user,
    roles,
  });

  const showAppsSection = showReportsLink || visibleExternalLinks.length > 0;

  if (!showAppsSection) {
    return null;
  }

  return (
    <Box mb="r">
      <H5 fontWeight="bold">Apps</H5>
      <Box my="r">
        <Divider light />
      </Box>
      <InternalAppLinks user={user} roles={roles} workspace={workspace} />
      {visibleExternalLinks.length > 0 && (
        <ExternalAppLinks links={visibleExternalLinks} />
      )}
    </Box>
  );
};

export default AppSwitcherContent;
